$component-class: 'awards-type-1';

.#{$component-class} {
  &__container {
    align-items: center;
  }

  &__text {
    display: flex;
    align-items: center;

    .me-heading {
      margin-bottom: 0;
      font-size: map-get($font-sizes, 4xl);

      @include below($breakpoint-desktop-md) {
        max-width: 530px;
        text-align: center;
      }

      @include above($breakpoint-desktop-md) {
        font-size: map-get($font-sizes, 6xl);
      }
    }
  }

  &__logos {
    display: flex;
    align-items: center;
  }

  &__logos-list {
    display: flex;
    gap: var(--spacing-sm);
    align-items: center;
    width: 100%;

    @include desktop {
      gap: var(--spacing-2xl);
    }
  }

  // 4 × 75 + 3 × 16(gap) = 348px → mobile column content ≥ 380px viewport
  // 4 × 122 + 3 × 32(gap) = 584px → 50%-column content ≥ 1280px viewport
  &__logo-item {
    width: 75px;
    height: 91px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    @include above(1280px) {
      width: 122px;
      height: 129px;
    }
  }

  &__logo-image {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  &--text-left {
    .#{$component-class}__text {
      justify-content: flex-start;
    }

    .#{$component-class}__logos {
      justify-content: flex-end;

      .#{$component-class}__logos-list {
        justify-content: flex-end;

        @include below($breakpoint-desktop) {
          justify-content: center;
        }
      }
    }
  }

  &--text-right {
    .#{$component-class}__text {
      justify-content: flex-end;
    }

    .#{$component-class}__logos {
      justify-content: flex-start;
    }
  }

  &--long-text {
    .me-heading {
      font-size: map-get($font-sizes, 2xl);

      @include desktop {
        font-size: map-get($font-sizes, 4xl);
      }
    }
  }

  &--light {
    .me-heading {
      color: var(--text-color-primary);
    }
  }

  &--dark {
    .me-heading {
      color: var(--text-color-alternate);
    }
  }

  @include below-desktop {
    .#{$component-class}__text {
      justify-content: center;
      margin-bottom: var(--spacing-4xl);
    }

    .#{$component-class}__logos {
      justify-content: center;
    }

    .#{$component-class}__logos-list {
      justify-content: center;
      flex-wrap: wrap;
      gap: var(--spacing-md);
    }
  }
}
